<script setup>
import { router } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import Welcome from '@/Pages/Dashboard/Welcome.vue';
import DashboardSidebar from '@/Jetstream/DashboardSidebar.vue';

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";
const default_text = router.page.props.ziggy.default_text;

let no_toolkits_text = null;

if(default_text) {
    no_toolkits_text = default_text.filter((item) => {
        return item.key == "no_toolkits";
    });
    no_toolkits_text = no_toolkits_text[0];
}

</script>

<template>
    <AppLayout title="Dashboard">

        <div class="container mx-auto flex flex-col lg:flex-row justify-between w-full">

            <div id="sos-programme-dashboard-sidebar" class="order-2 lg:order-1 w-full lg:w-1/4 xl:w-1/5 min-h-screen p-10 pt-5">
                <DashboardSidebar :programme="programme" :organisation="organisation" />
            </div>

            <div class="order-1 lg:order-2 w-full lg:w-3/4 xl:w-4/5 sos-programme-dashboard-content">
                <div class="overflow-hidden">
                    <h2 class="dashboard-title pt-5 pl-10">
                        {{ $t('dashboard.title') }}
                    </h2>
                    <div class="p-10 pt-5 lg:pr-0">
                        <div v-if="organisation">
                            <div v-if="organisation.no_toolkits" v-html="organisation.no_toolkits"></div>
                            <div v-if="!organisation.no_toolkits && programme.no_toolkits" v-html="programme.no_toolkits"></div>
                            <div v-if="(no_toolkits_text && no_toolkits_text.content) && !organisation.no_toolkits && !programme.no_toolkits" v-html="no_toolkits_text.content"></div>
                            <div v-if="(!no_toolkits_text || !no_toolkits_text.content) && !organisation.no_toolkits && !programme.no_toolkits">
                                <p>{{ $t('toolkit.no_toolkits') }}</p>
                            </div>
                        </div>

                        <div v-if="!organisation">
                            <div v-if="programme.no_toolkits" v-html="programme.no_toolkits"></div>
                            <div v-if="(no_toolkits_text && no_toolkits_text.content) && !programme.no_toolkits" v-html="no_toolkits_text.content"></div>
                            <div v-if="(!no_toolkits_text || !no_toolkits_text.content) && !programme.no_toolkits">
                                <p>{{ $t('toolkit.no_toolkits') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>
